
/* START_TEMPLATE */
define('hbs!app/templates/guest_collection',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "<div class=\"ticket-holders\" id=\"ticket-holders-"
    + escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"id","hash":{}}) : helper)))
    + "\">\n  <ul class=\"ticket-holders-list\">\n  </ul>\n</div>\n";
}});
Handlebars.registerPartial('app/templates/guest_collection', t);
return t;
});
/* END_TEMPLATE */
;
